import { Tabs } from "@components/tabs-nav/TabNav.types";

export const SystemBhTabs: Tabs = {
  Operations: {
    Banner: { id: "ops-banner", name: "Banner" },
    MobileApp: { id: "mobile-app", name: "MobileApp" },
    StatsTotal: { id: "stats-total", name: "Booking Stats Total" }
  }
};
